import React, { useState, useEffect } from "react";
import { Card, Button, Box, Stack, Typography } from "@mui/material";
import PDFViewerModal from "src/components/PDFViewerModal";
import { obtenerPdf } from "src/api/pdfService";
import { useAuth } from "../../../contexts/AuthContext"; 

export default function UsuariosSinActividad() {
    const { user } = useAuth();
    const usuarioId = user?.idUsuario;
    const [pdfUrl, setPdfUrl] = useState<Uint8Array | null>(null);

    const verReporte = async () => {
        if (!usuarioId) return;
        const data = await obtenerPdf("/dependientesSinUso/" + usuarioId);
        setPdfUrl(data);
    };

    useEffect(() => {
        let isMounted = true;

        const cargarReporte = async () => {
            if (!usuarioId) return;
            const data = await obtenerPdf("/dependientesSinUso/" + usuarioId);
            if (isMounted) {
                setPdfUrl(data);
            }
        };

        cargarReporte();

        return () => {
            isMounted = false;
        };
    }, [usuarioId]);

    return (
        <Box className="p-4">
            <Card sx={{ padding: 3 }}>
                <Stack 
                    direction="row" 
                    justifyContent="space-between" 
                    alignItems="center"
                    mb={2}
                >
                    <Typography variant="h6" fontWeight="600">
                        Reporte usuarios sin actividad
                    </Typography>

                    <Button variant="contained" onClick={verReporte}>
                        Actualizar PDF
                    </Button>
                </Stack>

                <Typography color="text.secondary">
                    Este reporte muestra los usuarios que no han usado la aplicación
                    en el período reciente.
                </Typography>
            </Card>

            <PDFViewerModal
                pdfUrl={pdfUrl}
                onClose={() => setPdfUrl(null)}
                title="Reporte de Usuarios sin Actividad"
            />
        </Box>
    );
}
